import "../scss/main.scss";

(function ($) {
  $(document).ready(function () {
    theme.init();
  });

  var theme = {
    init: function () {
      this.headerFunctions();
      this.runSliders();
      this.animations();
      this.accordion();
    },

    headerFunctions: function () {
      // mobile menu
      $(".toggle-nav").click(function (e) {
        e.preventDefault();
        $("body").toggleClass("fixed");
        $(".mobile-menu").fadeIn();
        $(".mobile-menu .inner").addClass("opened");
      });

      $(".mobile-menu .menu li.menu-item-has-children").append(
        '<span class="toggle"></span>'
      );
      $(".mobile-menu .menu li.menu-item-has-children .toggle").on(
        "click",
        function () {
          $(this).toggleClass("opened");
          $(this).parent().toggleClass("active");
          $(this).parent().find("> .sub-menu").slideToggle();
        }
      );

      $(".mobile-menu .inner a.close").on("click", function (e) {
        e.preventDefault();
        $(".mobile-menu .inner").removeClass("opened");
        $(".mobile-menu").fadeOut();
        $("body").removeClass("fixed");
      });

      // sticky header
      $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        if (scroll >= 400) {
          $("header.navbar").addClass("fixed");
          $("body").addClass("scrolling");
        } else {
          $("header.navbar").removeClass("fixed");
          $("body").removeClass("scrolling");
        }
      });
    },

    runSliders: function () {
      $(".hero-slider").on("init", function (event, slick) {
        $(".hero-slider .slick-current").addClass("animated");
      });

      $(".hero-slider").on(
        "afterChange",
        function (event, slick, currentSlide, nextSlide) {
          $(".hero-slider .slide").removeClass("animated");
          $(".hero-slider .slick-active").addClass("animated");
        }
      );

      $(".hero-slider").slick({
        arrows: true,
        dots: true,
        fade: true,
        prevArrow: "<span class='slick-arrow slick-prev'></span>",
        nextArrow: "<span class='slick-arrow slick-next'></span>",
        autoplay: true,
        infinite: true,
        autoplaySpeed: 5000,
      });

      $(".hero-slider").each(function () {
        $(this)
          .find(".slick-arrow, ul.slick-dots")
          .wrapAll('<div class="slider-nav"></div>');
      });

      $(".images-carousel").slick({
        arrows: false,
        dots: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });
    },

    animations: function () {
      // on viewport animations
      function isInViewport(node) {
        var rect = node.getBoundingClientRect();
        return (
          (rect.height > 0 || rect.width > 0) &&
          rect.bottom >= 0 &&
          rect.right >= 0 &&
          rect.top <=
            (window.innerHeight || document.documentElement.clientHeight) &&
          rect.left <=
            (window.innerWidth || document.documentElement.clientWidth)
        );
      }
      function animations() {
        $(".section-title, .services-grid, .icon-list, .animated-cols, .wp-block-media-text").each(
          function () {
            if (isInViewport(this)) {
              $(this).addClass("inViewport");
            }
          }
        );
      }

      animations();

      $(window).scroll(function () {
        animations();

        $(".counter .number").each(function () {
          if (isInViewport(this)) {
            $(this).counter({
              placeholder: "0",
              countFrom: 0,
            });
          }
        });
      });
    },

    accordion: function () {
      $(".accordion").accordion({
        header: "> .item > span.title",
        heightStyle: "content",
        collapsible: true,
      });
      $(".accordion.is-style-alternative").accordion({
        active: false,
      });
    },
  };
})(jQuery);
